import { useEffect, useState } from "react";
import { useStoryblokApi } from "@storyblok/react";
import { ChevronDown } from "lucide-react";

const Menu = () => {
  const storyblokApi = useStoryblokApi();

  const [solutionsItems, setSolutionsItems] = useState([]);
  const [devicesItem, setDevicesItem] = useState(null);
  const [dashboardsItem, setDashboardsItem] = useState(null);
  const [newsItem, setNewsItem] = useState(null);
  const [contactItem, setContactItem] = useState(null);
  const [isSolutionsOpen, setIsSolutionsOpen] = useState(false);

  useEffect(() => {
    const fetchMenu = async () => {
      try {
        const { data } = await storyblokApi.get("cdn/datasource_entries", {
          datasource: "main-menu",
          version: "published",
        });

        const entries = data.datasource_entries || [];

        // All /solutions/... pages (drop-down items)
        const solutions = entries.filter(
          (item) =>
            item.value?.startsWith("/solutions/") &&
            item.value !== "/solutions"
        );

        const findByName = (name) =>
          entries.find(
            (item) => item.name.trim().toLowerCase() === name.toLowerCase()
          );

        setSolutionsItems(solutions);
        setDevicesItem(findByName("Devices"));
        setDashboardsItem(findByName("Dashboards & Reports"));
        setNewsItem(findByName("News & Resources"));
        setContactItem(findByName("Contact Us"));
      } catch (err) {
        console.error("Error fetching menu:", err);
      }
    };

    fetchMenu();
  }, [storyblokApi]);

  return (
    <nav className="flex items-center w-full text-sm">
      {/* Left group of menu items */}
      <div className="flex items-center space-x-8">
        {/* Home button with the Radar logo, this is now an asset upload but I'm still keeping the placeholder text if a logo isn't uploaded so that content editors can make the visual connection */}
        <a
          href="/"
          className="font-medium text-black hover:text-[#1371DC] transition-colors"
        >
          BlackBerry Radar
        </a>

        {/* Solutions dropdown, this isn't an actual solutions page there are just pages in the solutions section */}
        <div
          className="relative"
          onMouseEnter={() => setIsSolutionsOpen(true)}
          onMouseLeave={() => setIsSolutionsOpen(false)}
        >
          <button
            type="button"
            className="inline-flex items-center gap-1 text-black hover:text-[#1371DC] transition-colors"
          >
            <span>Solutions</span>
            <ChevronDown
              className={`w-4 h-4 transition-transform ${
                isSolutionsOpen ? "rotate-180" : ""
              }`}
            />
          </button>

          {isSolutionsOpen && solutionsItems.length > 0 && (
            <div className="absolute left-0 mt-2 w-80 bg-white text-black rounded shadow-lg py-2 z-40">
              {solutionsItems.map((solution) => (
                <a
                  key={solution.id}
                  href={solution.value}
                  className="block px-4 py-2 text-sm hover:bg-gray-100"
                >
                  {solution.name}
                </a>
              ))}
            </div>
          )}
        </div>

        {/* Devices */}
        {devicesItem && (
          <a
            href={devicesItem.value}
            className="text-black hover:text-[#1371DC] transition-colors"
          >
            {devicesItem.name}
          </a>
        )}

        {/* Dashboards & Reports */}
        {dashboardsItem && (
          <a
            href={dashboardsItem.value}
            className="text-black hover:text-[#1371DC] transition-colors"
          >
            {dashboardsItem.name}
          </a>
        )}

        {/* News & Resources */}
        {newsItem && (
          <a
            href={newsItem.value}
            className="text-black hover:text-[#1371DC] transition-colors"
          >
            {newsItem.name}
          </a>
        )}
      </div>

      {/* Right group */}
      <div className="flex items-center space-x-8 ml-auto">
        {/* Contact Us */}
        {contactItem && (
          <a
            href={contactItem.value}
            className="text-black hover:text-[#1371DC] transition-colors"
          >
            {contactItem.name}
          </a>
        )}

        {/* Portal Login */}
        <a
          href="/portal-login"
          className="text-black hover:text-[#1371DC] transition-colors"
        >
          Portal Login
        </a>
      </div>
    </nav>
  );
};

export default Menu;
